import React from 'react';
import InfoCard from './InfoCard';
import MontserratText from './MontserratText';

/**
 * HorizontalScroll (теперь Masonry) Component
 * Masonry сетка карточек в стиле Montserrat (3-4 в ряд)
 * @param {Array} items - Массив элементов с icon, title, description, subtitle
 * @param {string} title - Заголовок секции
 * @param {string} description - Описание секции
 */
export default function HorizontalScroll({
  items = [],
  title = '',
  description = '',
  className = '',
}) {
  return (
    <div className={className}>
      {(title || description) && (
        <div className='mb-12 text-center max-w-4xl mx-auto'>
          {title && (
            <MontserratText variant="h2" weight="bold" className="mb-6">
              {title}
            </MontserratText>
          )}
          {description && (
            <MontserratText variant="body" color="text-slate-600" className="max-w-2xl mx-auto">
              {description}
            </MontserratText>
          )}
        </div>
      )}

      <div className="columns-1 md:columns-2 lg:columns-3 xl:columns-4 gap-6 space-y-6">
        {items.map((item, index) => (
          <div key={index} className="break-inside-avoid">
            <InfoCard
              icon={item.icon}
              title={item.title}
              subtitle={item.subtitle}
            >
              {item.description}
            </InfoCard>
          </div>
        ))}
      </div>
    </div>
  );
}
